// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--1b89q","title":"hero-module--title--CRLEZ","subtitle":"hero-module--subtitle--3XNao"};